import { Pipe, PipeTransform } from '@angular/core'

@Pipe({
  name: 'centsToCurrency',
  standalone: true,
})
export class CentsToCurrencyPipe implements PipeTransform {
  transform(cents: number | null, currency = 'EUR'): string {
    if (cents === null || cents === undefined) {
      return `- ${currency}`
    }
    const amount = cents / 100
    return `${amount.toFixed(2)} ${currency}`
  }
}
